module.exports = __webpack_public_path__ + "img/solutionImg5.da4fa46e.png";